import React, { useEffect, useContext, useCallback } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/packages/blue-book-player/library/button-with-icon';
import {
  BluebookAnnotationsContext,
  TYPES,
} from 'chameleon/packages/blue-book-player/state/BluebookAnnotationsContext';
import NotesList from 'chameleon/packages/blue-book-player/library/NotesColumn/NotesList';

const NotesColumn = (props) => {
  const {
    state: { isNotesColumnExpanded },
    dispatch,
  } = useContext(BluebookAnnotationsContext);

  const {
    isInLeftColumn,
    parentElement,
    learnosityItemReference,
    itemRefAnnotations,
  } = props;
  useEffect(() => {
    if (
      parentElement &&
      isInLeftColumn &&
      !parentElement.classList.contains('expanded')
    ) {
      const leftColumnExpander = parentElement.querySelector(
        '[class^="left-column-expander"] button',
      );

      leftColumnExpander?.click();
    }
  }, [parentElement, isInLeftColumn, itemRefAnnotations]);

  const handleToggleNotesColumn = useCallback(() => {
    dispatch({ type: TYPES.TOGGLE_NOTES_COLUMN });
  });

  return (
    <div
      className={cn(
        'notes-column p-2 bg-bluebook-light-gray border-l-3 border-bluebook-gray9 flex relative',
        {
          'sticky top-0 min-h-full !px-0': isInLeftColumn,
          'w-[350px]': isNotesColumnExpanded,
          'w-[15px]': !isNotesColumnExpanded,
        },
      )}
    >
      <ButtonWithIcon
        icon="chevron_right"
        className={cn(
          'bg-bluebook-gray10 rounded-[0_100px_100px_0] border-bluebook-gray9 border-y-3 border-r-3 mt-auto py-7 hover:bg-bluebook-dark-gray absolute bottom-[10%] z-10',
          {
            'transform rotate-180 -left-[43px]': !isNotesColumnExpanded,
            'left-0': isNotesColumnExpanded,
          },
        )}
        iconClassName="!fill-bluebook-light-gray"
        onClick={handleToggleNotesColumn}
        accessibility={{
          'aria-label': isNotesColumnExpanded ? 'Hide Notes' : 'Show Notes',
        }}
      />
      {isNotesColumnExpanded && (
        <NotesList
          learnosityItemReference={learnosityItemReference}
          itemRefAnnotations={itemRefAnnotations}
        />
      )}
    </div>
  );
};

NotesColumn.propTypes = {
  isInLeftColumn: PropTypes.bool.isRequired,
  parentElement: PropTypes.object,
};

NotesColumn.defaultProps = {
  parentElement: null,
};

export default NotesColumn;
